import Footer from 'components/Header/Footer'
import Header from 'components/Header/Header'
import JapanList from './JapanList'
import React from 'react'

const JapanUni = () => {
  return (
    <div className='main'>
<Header/>
<JapanList/>
<Footer/>

    </div>
  )
}

export default JapanUni